__turbopack_context__.v({
  "container": "MgCuyq_container",
  "feedbackList": "MgCuyq_feedbackList",
  "headingRow": "MgCuyq_headingRow",
  "placeholderList": "MgCuyq_placeholderList",
  "seeMoreButton": "MgCuyq_seeMoreButton",
});
